import { Link } from 'react-router-dom';
import ServerIpDisplay from '../ServerIpDisplay';

const index = () => {
  return (
    <footer>
      <div className="container-fluid px-0 py-3">
        <div className="row">
          <div className="col-lg-6">
            <p className="mb-3 mb-lg-0 text-center text-lg-start">
              © Castle Software, Inc. 2001-{new Date().getFullYear()}
            </p>
          </div>
          <div className="col-lg-6">
            <p className="mb-0 text-center text-lg-end">
              <Link
                to="https://harriseducationsolutions.com/wp-content/uploads/2026/09/SaaS-Agreement-Castle-Software-Inc.-SaaS-Agreement-used-for-Castle-Learning.pdf-Harris-Education-Nextcloud.pdf"
                key="termsOfServiceKey"
                target="_blank">
                Terms of Service
              </Link> 
              {' | '} 
              <Link
                to="https://harriseducationsolutions.com/privacy-policy/"
                key="policyLinkKey"
                target="_blank">
                Privacy Policy
              </Link> {' | '} <ServerIpDisplay />
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default index;
